import Vue from "vue";

export default {
  getExemptions({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
        ...(state.filterValue != "" && { status: state.filterValue }),
        ...(state.filterDate != null && { start_date: state.filterDate[0] }),
        ...(state.filterDate != null && { end_date: state.filterDate[1] }),
      };

      Vue.$http
        .get("/hrm/exemptions/view-all", { params })
        .then(response => {
          commit("exemptionData", response.data.results);
          commit("exemptionTotal", response.data.total);
          commit("tableLoader", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  handleSizeChange({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    commit("currentPage", 1);
    dispatch("getExemptions");
    dispatch("getApprovals");
  },
  handleCurrentChange({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getExemptions");
    dispatch("getApprovals");
  },
  createExemption(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/hrm/exemptions", data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  updateExemption(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/exemptions/${id}`, data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExemptionById(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/exemptions/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExemption({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/exemptions/${id}`)
        .then(response => {
          commit("currentExemption", response.data);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  deleteExemptions(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/exemptions/[${id}]`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getBranches({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/branches")
        .then(response => {
          commit("branches", response.data.results);
          resolve(response.data.results);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getApprovals({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("tableLoader", true);

      const params = {
        page: state.currentPage,
        perPage: state.perPage,
        ...(state.searchQuery != "" && { search_query: state.searchQuery }),
      };

      Vue.$http
        .get("/hrm/exemptions/settings/approvals", { params })
        .then(response => {
          commit("approvalsData", response.data.results);
          commit("exemptionApprovalTotal", response.data.total);
          commit("tableLoader", false);
          resolve(response.data);
        })
        .catch(error => {
          commit("tableLoader", false);
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  getApproval({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`hrm/exemptions/settings/approvals/${id}`)
        .then(response => {
          commit("currentApproval", response.data);
          resolve(response);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  createExemptionApproval(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post("/hrm/exemptions/settings/approvals", data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          Vue.$notification.error(error.message, {
            offset: 120,
          });
          reject(error);
        });
    });
  },
  updateExemptionApproval(_, { data, id }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/exemptions/settings/approvals/${id}`, data)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteExemptionApproval(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`hrm/exemptions/settings/approvals/[${id}]`)
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getEmployeeGrades({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/organization/employees/settings/grades")
        .then(response => {
          commit("employeeGrades", response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getDepartments({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("organization/departments")
        .then(response => {
          commit("departments", response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  changeExemptionStatus(_, { ids, endpoint }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/exemptions/${endpoint}`, { exemption_request_ids: ids })
        .then(response => {
          Vue.$notification.success(response.message);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
